import React from "react";
import { faCalendarAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CallbirdButton = () => {
    return (
        <a
            onClick={(e) => e.preventDefault()}
            href="https://www.callbird.com/insinkeratoruk/"
            data-callbird-org="daa7ecd227"
            data-callbird-mode="popup"
            data-callbird-online-text="Instant video call"
            data-callbird-online-sub="Available now — or book a time"
            data-callbird-offline-text="Book a meeting"
            data-callbird-offline-sub="Find a time that works for you"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px 20px",
                borderRadius: "12px",
                background: "#ffffff",
                color: "#111827",
                textDecoration: "none",
                fontFamily: "system-ui,-apple-system,sans-serif",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                border: "1px solid #e5e7eb",
            }}
        >
            <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-brand-primary">
                <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="text-brand-white"
                />
            </div>

            <span
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                }}
            >
                <span
                    data-callbird-label=""
                    style={{
                        fontWeight: 600,
                        fontSize: "15px",
                        lineHeight: 1.2,
                    }}
                >
                    Book a meeting
                </span>
                <span
                    data-callbird-sublabel=""
                    style={{
                        fontSize: "13px",
                        opacity: 0.6,
                        lineHeight: 1.2,
                    }}
                >
                    Find a time that works for you
                </span>
            </span>
        </a>
    );
};
